import { render, staticRenderFns } from "./ElectricityIcon.vue?vue&type=template&id=d9defb28&"
import script from "./ElectricityIcon.vue?vue&type=script&lang=js&"
export * from "./ElectricityIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports